import React, { useEffect, useState } from "react";

//redux
import { connect, useDispatch, useSelector } from "react-redux";

//MUI
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
} from "@material-ui/core";
import { Cancel } from "@material-ui/icons";

//types
import { CLOSE_WHITE_LISTED_DEVICE_DIALOG } from "../../store/whiteListedDevices/types";

//action
import { createNewWhiteListedDevice, editWhiteListedDevice } from "../../store/whiteListedDevices/action";
import { permissionError } from "../../util/Alert";

const WhiteListDeviceDialog = (props) => {
  const dispatch = useDispatch();

  const { dialog: open, dialogData } = useSelector((state) => state.whiteListedDevices);
  const hasPermission = useSelector((state) => state.admin.admin.flag);

  const [mongoId, setMongoId] = useState("");
  const [deviceId, setDeviceId] = useState("");


  const [errors, setError] = useState({
    deviceId:""
  });

  useEffect(() => {
    if (dialogData) {
      console.log("Dialog Data: ", dialogData);
      setMongoId(dialogData._id);
      setDeviceId(dialogData.deviceId);
    }
  }, [dialogData]);

  useEffect(
    () => () => {
      setError({
        deviceId:""
      });
      setMongoId("");
      setDeviceId("");
    },
    [open]
  );

  useEffect(() => {
    window.onbeforeunload = closePopup();
  }, []);

  const closePopup = () => {
    dispatch({ type: CLOSE_WHITE_LISTED_DEVICE_DIALOG });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!deviceId) {
      const errors = {};
      if (!deviceId) errors.link = "Device ID is Required!";
      return setError({ ...errors });
    }
    
    if (!hasPermission) return permissionError();
    const payload = {
      deviceId: deviceId,
    }

    if (mongoId) {
      props.editWhiteListedDevice(mongoId, payload);
    } else {
      props.createNewWhiteListedDevice(payload);
    }
  };

  return (
    <>
      <Dialog
        open={open}
        aria-labelledby="responsive-dialog-title"
        onClose={closePopup}
        disableBackdropClick
        disableEscapeKeyDown
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle id="responsive-dialog-title">
          <span className="text-danger font-weight-bold h4"> White-list Device </span>
        </DialogTitle>

        <IconButton
          style={{
            position: "absolute",
            right: 0,
          }}
        >
          <Tooltip title="Close">
            <Cancel className="text-danger" onClick={closePopup} />
          </Tooltip>
        </IconButton>
        <DialogContent>
          <div className="modal-body pt-1 px-1 pb-3">
            <div className="d-flex flex-column">
              <form>
                <div className="form-group">
                  <label className="mb-2 text-gray">Device ID</label>
                  <input
                    type="text"
                    className="form-control"
                    required=""
                    value={deviceId}
                    onChange={(e) => {
                      setDeviceId(e.target.value);

                      if (!e.target.value) {
                        return setError({
                          ...errors,
                          deviceId: "Device ID is Required!",
                        });
                      } else {
                        return setError({
                          ...errors,
                          deviceId: "",
                        });
                      }
                    }}
                  />
                   {errors.deviceId && (
                    <div className="ml-2 mt-1">
                      {errors.deviceId && (
                        <div className="pl-1 text__left">
                          <span className="text-red">{errors.deviceId}</span>
                        </div>
                      )}
                    </div>
                  )}
                </div>
                  <div className={"mt-5"}>
                  <button
                    type="button"
                    className="btn btn-outline-info ml-2 btn-round float__right icon_margin"
                    onClick={closePopup}
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    className="btn btn-round float__right btn-danger"
                    onClick={handleSubmit}
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default connect(null, { createNewWhiteListedDevice, editWhiteListedDevice })(WhiteListDeviceDialog);
